import type { IconData } from '@stacksjs/iconify-core'

export const candle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 11v6h2v-6zm4 6h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h5V9h6zM2 19v1h16v-1zm8-10.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3m0-1.952c.552 0 1-.48 1-1c0-.466-.333-1.109-1-2c-.667.891-1 1.534-1 2c0 .52.448 1 1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default candle
